<template>
  <div>
    <error-reveal :error="error"></error-reveal>
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Partners</h6>
      </div>
      <div class="card-body">
        <card-list
          :items="items"
          emptytext="No partners."
          additemtext="Create partner"
          refreshtext="Refresh"
          @additem="onAddNewItem"
          @itemaction="onItemAction"
          @refresh="onGridRefresh"
        >
          <template v-slot:titleHead>
            <div class="">
              <select v-model="statusFilter" class="custom-select custom-select-sm">
                <option value="active">Only active partners</option>
                <option value="inactive">Only inactive partners</option>
                <option value="all">All partners</option>
              </select>
            </div>
          </template>
          <template v-slot:card="slotProps">
            <div class="card-body" v-bind:class="{'opacity-50': !slotProps.item.active}">
              <div class="row">
                <div class="col-md-6">
                   <span class="card-title clickable h5" @click="onItemAction('clients', slotProps.item)">{{slotProps.item.name}}</span>
                </div>
                <div class="col-md-6 text-right">
                  <button type="button" class="btn btn-primary btn-xs" @click="onItemAction('edit', slotProps.item)">
                    <span><i class="fas fa-sm fa-edit"></i></span>
                  </button>
                  <button type="button" class="btn btn-primary btn-xs" @click="onItemAction('settings', slotProps.item)">
                    <span><i class="fas fa-sm fa-tools"></i></span>
                  </button>
                  <button type="button" class="btn btn-primary btn-xs" @click="onItemAction('analytics', slotProps.item)">
                    <span><i class="fas fa-sm fa-chart-bar"></i></span>
                  </button>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-12">
                  <p class="small text-muted mb-1" v-if="slotProps.item.contactName">Contact: <b>{{ slotProps.item.contactName }}</b></p>
                  <p class="small text-muted mb-1" v-if="slotProps.item.contactPhone">Contact phone: <b>{{ slotProps.item.contactPhone }}</b></p>
                  <p class="small mb-0">
                    <a v-if="slotProps.item.active" href="#" class="" @click.prevent="onItemAction('inactivate', slotProps.item)"><i class="fas fa-sm fa-pause-circle"></i> Inactivate</a>
                    <a v-if="!slotProps.item.active" href="#" class="" @click.prevent="onItemAction('activate', slotProps.item)"><i class="fas fa-sm fa-play-circle"></i> Activate</a>
                  </p>
                  <p class="small mt-1 mb-0" v-if="slotProps.item.currentCampaignId">
                     <a href="#" class="" @click.prevent="onItemAction('download', slotProps.item)"><i class="fas fa-sm fa-download"></i> Download performance</a>
                  </p>
                  <p class="small mt-1 mb-0" v-if="slotProps.item.currentCampaignId">
                     <a href="#" class="" @click.prevent="onItemAction('view-campaign-analytics', slotProps.item)"><i class="fas fa-sm fa-chart-bar"></i> View campaign analytics</a>
                  </p>
                </div>
              </div>
            </div>
          </template>
        </card-list>
      </div>
    </div>
    <data-store
      ref="store"
      :service="service"
      :filter="filters"
      :sort="sort"
      @beforeload="onBeforeLoad"
      @afterload="onAfterLoad"
      @dataloaded="onDataLoaded"
      @loaderror="onLoadError"
    ></data-store>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import * as mutationTypes from '../../store/mutation-types'
import CardList from '../../lists/CardList'
import DataStore from '../../data/Store'
import ErrorReveal from '../../errors/Reveal'
import partnerService from '../../services/partner'
import Confirm from '../../mixins/Confirm'
import SafeString from '../../utils/SafeString'

function defaultFilters () {
  return { active: true }
}

export default {
  name: 'partners-list',
  mixins: [Confirm],
  components: {
    CardList,
    DataStore,
    ErrorReveal
  },
  data () {
    return {
      statusFilter: 'active',
      filters: defaultFilters(),
      items: [],
      service: partnerService.list,
      sort: null,
      error: null
    }
  },
  watch: {
    statusFilter: 'onStatusFilterChanged'
  },
  methods: {
    ...mapMutations([mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF]),
    onAddNewItem () {
      this.$router.push({name: 'partner-edit'})
    },
    onBeforeLoad () {
      this[mutationTypes.BUSY_ON]()
    },
    onAfterLoad () {
      this[mutationTypes.BUSY_OFF]()
    },
    onDataLoaded (items, result) {
      this.items = items.map(this.parseItem)
    },
    onLoadError (error) {
      this[mutationTypes.BUSY_OFF]()
      this.error = error
    },
    onStatusFilterChanged (newStatusFilter) {
      switch (newStatusFilter) {
        case 'active':
          this.filters.active = true
          break
        case 'inactive':
          this.filters.active = false
          break
        case 'all':
        default:
          this.filters.active = undefined
          break

      }
      this.onGridRefresh()
    },
    onItemAction (action, item) {
      if (action === 'clients') {
        this.$router.push({name: 'partner-client-list', params: {partnerId: item.id}})
      } else if (action === 'edit') {
        this.$router.push({name: 'partner-edit', params: {id: item.id}})
      } else if (action === 'inactivate') {
        this.inactivate(item.id)
      } else if (action === 'activate') {
        this.activate(item.id)
      } else if (action === 'settings') {
        this.$router.push({name: 'partner-settings', params: {partnerId: item.id}})
      } else if (action === 'analytics') {
        this.$router.push({name: 'partner-analytics', params: {partnerId: item.id}})
      }
    },
    activate (id) {
      this.confirm('Activate', new SafeString('Are you sure?')).then((confirmed) => {
        if (confirmed) {
          this[mutationTypes.BUSY_ON]()
          partnerService.activate(id).then((result) => {
            this[mutationTypes.BUSY_OFF]()
            if (this.$refs.store) {
              this.onGridRefresh()
            } else if (this.$refs.datastore) {
              this.$refs.datastore.fetchData()
            }
          }).catch((err) => {
            this[mutationTypes.BUSY_OFF]()
            this.error = err
          })
        }
      })
    },
    inactivate (id) {
      this.confirm('Inactivate', new SafeString('Are you sure?')).then((confirmed) => {
        if (confirmed) {
          this[mutationTypes.BUSY_ON]()
          partnerService.inactivate(id).then((result) => {
            this[mutationTypes.BUSY_OFF]()
            if (this.$refs.store) {
              this.onGridRefresh()
            } else if (this.$refs.datastore) {
              this.$refs.datastore.fetchData()
            }
          }).catch((err) => {
            this[mutationTypes.BUSY_OFF]()
            this.error = err
          })
        }
      })
    },
    onGridRefresh () {
      this.$refs.store.load()
    },
    onDownloadPerformance (item) {
      partnerService.download(item.id)
    },
    parseItem (rawData) {
      return {
        id: rawData.id,
        name: rawData.name,
        contactName: rawData.contactName,
        contactPhone: rawData.contactPhone,
        active: rawData.active !== undefined ? rawData.active : true,
        stats: rawData.stats
      }
    },
    precisionRound (number, precision) {
      var factor = Math.pow(10, precision)
      return Math.round(number * factor) / factor
    },
    renderAds (rawData) {
      var ads = rawData.stats.ads
      return `${ads.total} / ${ads.active}`
    },
    renderBuffer (rawData) {
      var buffer = rawData.stats.buffer
      return buffer ? `${buffer.total} / ${buffer.processed}` : '-'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  // @import '../../../sass/foundation-import';
  // @import '../../../sass/layouts/list';
</style>
